import React, { useState } from 'react';
import './BookDemoModal.css';
import { apiFetch } from '../utils/api';

const BASE_URL = process.env.REACT_APP_OFFSETBRIDGE_APP_URL

export default function BookDemoModal({ isOpen, onClose }) {
  const [form, setForm] = useState({ name: '', company: '', email: '' });
  const [status, setStatus] = useState(null);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('sending');
    try {

      console.log(BASE_URL)

      console.log(`${BASE_URL}/api/book-demo`)

      const res = await apiFetch(`${BASE_URL}/api/book-demo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      if (!res.ok) throw new Error(await res.text());
      setStatus('sent');
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

// In your BookDemoModal.jsx file, update the JSX structure:

if (!isOpen) return null;
return (
  <div className="modal-backdrop">
    <div className="modal">
      <button className="close-btn" onClick={onClose}>×</button>
      <h2>Book a Demo</h2>
      <p className="modal-subtitle">
        Please fill in your contact details and we will contact you to schedule a demo. Thank you!
      </p>
      <form onSubmit={handleSubmit}>
        <label>
          Name
          <input name="name" value={form.name} onChange={handleChange} required />
        </label>
        <label>
          Company
          <input name="company" value={form.company} onChange={handleChange} required />
        </label>
        <label>
          Email
          <input type="email" name="email" value={form.email} onChange={handleChange} required />
        </label>
        <button 
          type="submit" 
          disabled={status==='sending'}
          className={status === 'sent' ? 'success-state' : ''}
        >
          {status === 'sending' ? 'Sending…' : status === 'sent' ? '✓' : 'Submit'}
        </button>
      </form>
      {status==='sent' && <p className="success">Thank you! We'll be in touch.</p>}
      {status==='error' && <p className="error">Oops, something went wrong.</p>}
    </div>
  </div>
);
}
